import { createAsyncThunk } from '@reduxjs/toolkit';

import {
    PatchCatalogItemsRequest,
    PatchCatalogItemsResponse,
} from 'entities/CatalogItem/model/types/CatalogItemSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const reorderInventoryItemService = createAsyncThunk<
    PatchCatalogItemsResponse,
    PatchCatalogItemsRequest,
    ThunkConfig<any>
>('catalogItem/reorderFromInventory', async ({ data, catalogId }, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.patch<PatchCatalogItemsResponse>(
            `/v1/catalogs/${catalogId}/items`,
            data,
        );

        // State updates are now handled in the slice's extraReducers
        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
